import React, { useEffect, useState } from "react";
import SlickSlider from "../SlickSlider/SlickSlider";
import icon01 from "../../assets/img/icon/choose_icon01.svg";
import icon02 from "../../assets/img/icon/choose_icon02.svg";
import icon03 from "../../assets/img/icon/choose_icon03.svg";
import icon04 from "../../assets/img/icon/choose_icon04.svg";
import icon05 from "../../assets/img/icon/choose_icon05.svg";
import WhyChooseUsItem from "./WhyChooseUsItem";

const WhyChooseUs = () => {
  const slickSettings = {
    dots: false,
    infinite: true,
    speed: 8000,
    autoplay: true,
    arrows: false,
    slidesToShow: 5,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 1440,
        settings: {
          slidesToShow: 4,
        },
      },
      {
        breakpoint: 1200,
        settings: {
          slidesToShow: 4,
          slidesToScroll: 1,
          infinite: true,
        },
      },
      {
        breakpoint: 992,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          arrows: false,
        },
      },
      {
        breakpoint: 575,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          arrows: false,
        },
      },
    ],
  };

  const slider_items = [
    {
      src: icon01,
      alt: "",
      link: "/",
      title: "Fast, Accurate Diagnostics",
      description:
        "Get AI-driven diagnoses in minutes—backed by real patient data, wearable insights, and orthopaedic expertise.",
    },
    {
      src: icon02,
      alt: "",
      link: "/",
      title: "Secure & Transparent",
      description:
        "Your health data is protected on a Blockchain 4.0 ledger, fully compliant with GDPR and HIPAA.",
    },
    {
      src: icon03,
      alt: "",
      link: "/",
      title: "Smart Healthcare Integration",
      description:
        "Combining AI, IoT, and token rewards, DIAG supports dynamic treatment plans and incentivizes healthy behavior.",
    },
    {
      src: icon04,
      alt: "",
      link: "/",
      title: "Seamless Interoperability",
      description:
        "Use DIAG for healthcare payments, access premium features, or get partner discounts—all in a connected ecosystem.",
    },
    {
      src: icon05,
      alt: "",
      link: "/",
      title: "Scalable & Global",
      description:
        "Diagnostica is expanding fast—from Australia to Asia—covering foot, knee, hip, and shoulder conditions globally.",
    },
  ];

  const initalState = 0;
  const [count, setCount] = useState(initalState);

  useEffect(() => {
    const interval = setInterval(() => {
      setCount((old) => (old == 6 ? 0 : old + 1));
    }, 3000);

    return () => clearInterval(interval);
  }, []);

  const toMultiply = 100 / slider_items.length;

  return (
    <section className="choose-area pb-130">
      <div className="container">
        <div className="row justify-content-center">
          <div className="col-xl-6">
            <div className="section-title text-center mb-50">
              <h2 className="title">
                Why Choose <span> DIAG </span> Token?
              </h2>
              <p className="merriweather-sans mt-3">
                DIAG Token powers a revolutionary healthcare ecosystem designed
                for smarter, faster, and more affordable musculoskeletal care.
                Here’s why it stands out:
              </p>
            </div>
          </div>
        </div>

        <div className="row choose-active">
          <SlickSlider settings={slickSettings}>
            {slider_items.map((item, index) => (
              <div key={index} className="col-lg-3">
                <WhyChooseUsItem item={item} />
              </div>
            ))}
          </SlickSlider>
        </div>

        <div className="slide-progressbar d-block d-md-none">
          <div
            style={{
              // width: `${count * toMultiply}%`,
              backgroundSize: `${count * toMultiply}% 100%`,
            }}
            className="slide-filler"
          />
        </div>
      </div>
    </section>
  );
};

export default WhyChooseUs;
